module.exports = __webpack_public_path__ + "static/media/3.1bf9d58d.JPG";